import $ from 'jquery'
import { createAlert } from 'dom/window'
// import _ from 'lodash';
// import { fetchJSONData } from '_utils';
import { axiosInstance as axios, handleAxiosErrors } from '_utils'
import config from 'store/_config'
import { requestCart as requestCheckoutCart } from '../actions/checkoutActions'
import { convertPostDataIntoMutationParams, convertUpdateMemberPostData } from '../actions/userActions'
import {
  requestProductPriceByID,
  requestProductsByIDs,
  requestProductsByVariationIDs,
} from '../actions/productsActions'
import { getProductsFullInfo } from '../selectors/defaultSelectors'
import { convertCartReportData, isAllGoodCartReport } from '../selectors/converterSelectors'
import { closeProductGridModal } from './productGridModalActions'
import { generateCartItem } from '../reducers/CartReducer'
import { requestFromServer, toggleOnBeforeUnload } from './cartActions'

/**
 * Overwrite whatever cart list data with the new one
 *
 * @param list
 * @returns {{type: string, list: *}}
 */
export const setBackorderList = (list) => {
  return {
    type: 'SET_BACKORDER_LIST',
    list: list,
  }
}

const setRemindProductValue = (value = false) => {
  return {
    type: 'SET_REMIND_PRODUCT_VALUE',
    value,
  }
}

export const removeBackOrderItem = (product) => {
  return (dispatch, getState) => {
    const { _backorderItemID_Case = null, _backorderItemID_Unit = null } = product
    let ids = []

    if (_backorderItemID_Case) {
      ids.push(_backorderItemID_Case)
    }
    if (_backorderItemID_Unit) {
      ids.push(_backorderItemID_Unit)
    }

    if (!ids.length) {
      createAlert(
        {
          message: 'Something went wrong when removing backorder item',
        },
        'error'
      )

      console.error('Unable to find _backorderItemID_Case or _backorderItemID_Unit. Aborting')

      return
    }

    dispatch({
      type: 'REMOVE_BACKORDER_ITEM',
      product: product,
    })

    toggleOnBeforeUnload(true)

    return axiosRemoveBackOrderItem(ids)
      .then(() => {
        return Promise.all([dispatch(requestFromServer())])
      })
      .then(() => {
        toggleOnBeforeUnload(false)

        if (document.getElementById('checkout')) {
          dispatch(requestCheckoutCart())
        }
      })
  }
}

export const removeBackOrderMultiItems = (products, Ids) => {
  return (dispatch, getState) => {
    if (!Ids?.length) {
      return
    }

    dispatch({
      type: 'REMOVE_BACKORDER_ITEMS',
      products: products,
    })

    toggleOnBeforeUnload(true)

    return axiosRemoveBackOrderItem(Ids)
      .then(() => {
        return Promise.all([dispatch(requestFromServer())])
      })
      .then(() => {
        toggleOnBeforeUnload(false)

        if (document.getElementById('checkout')) {
          dispatch(requestCheckoutCart())
        }
      })
  }
}

export const remindMeProduct = (productID, flag) => {
  return async (dispatch, getState) => {
    try {
      await axiosRemindMeProduct(productID, flag)

      dispatch(setRemindProductValue(flag))
    } catch (error) {
      handleAxiosErrors(error)
    }
  }
}

export const axiosRemindMeProduct = (productID, flag) => {
  const { url, query } = config.backorder.reminder

  const params = {
    query: query,
    variables: {
      productID,
      remindMe: flag,
    },
  }

  return axios.post(url, params, {
    withCredentials: true,
  })
}

/**
 * Axios to remove BackOrder Item
 *
 * @param id
 * @returns {AxiosPromise<any>}
 */
export const axiosRemoveBackOrderItem = (ids) => {
  const { url, query } = config.backorder.deleteItem

  let params = {
    query: query,
    variables: {
      IDs: ids,
    },
  }

  return axios.post(url, params, {
    withCredentials: true,
  })
}
export const setNotifyRestockViaEmail = (val) => {
  return (dispatch) => {
    let { url, query } = config.members.update

    const postData = { NotifyRestockViaEmail: val }
    const [mutationParams, inputParams, finalData] = convertPostDataIntoMutationParams(
      convertUpdateMemberPostData(postData)
    )
    dispatch({
      type: 'TOGGLE_NOTIFY_RESTOCK_EMAIL_LOADING',
      value: true,
    })
    query = query.replace('{mutationParams}', mutationParams).replace('{inputParams}', inputParams)

    return axios
      .post(
        url,
        {
          query,
          variables: finalData,
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        const data = response.data.data.updateMemberInfo
        dispatch({
          type: 'TOGGLE_NOTIFY_RESTOCK_EMAIL_LOADING',
          value: false,
        })
        dispatch({
          type: 'UPDATE_USER_DETAILS',
          details: {
            ...data,
          },
        })
      })
  }
}
export const setNotifyRestockViaSMS = (val) => {
  return (dispatch) => {
    let { url, query } = config.members.update

    const postData = { NotifyRestockViaSMS: val }
    const [mutationParams, inputParams, finalData] = convertPostDataIntoMutationParams(
      convertUpdateMemberPostData(postData)
    )
    dispatch({
      type: 'TOGGLE_NOTIFY_RESTOCK_SMS_LOADING',
      value: true,
    })
    query = query.replace('{mutationParams}', mutationParams).replace('{inputParams}', inputParams)

    return axios
      .post(
        url,
        {
          query,
          variables: finalData,
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        const data = response.data.data.updateMemberInfo
        dispatch({
          type: 'UPDATE_USER_DETAILS',
          details: {
            ...data,
          },
        })
        dispatch({
          type: 'TOGGLE_NOTIFY_RESTOCK_SMS_LOADING',
          value: false,
        })
      })
  }
}

export const setBackorderSms = (val) => {
  return (dispatch) => {
    let { url, query } = config.members.update

    const postData = { AccountReminderViaSMS: val }
    const [mutationParams, inputParams, finalData] = convertPostDataIntoMutationParams(
      convertUpdateMemberPostData(postData)
    )
    dispatch({
      type: 'TOGGLE_BACKORDER_SMS_LOADING',
      value: true,
    })
    query = query.replace('{mutationParams}', mutationParams).replace('{inputParams}', inputParams)

    return axios
      .post(
        url,
        {
          query,
          variables: finalData,
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        const data = response.data.data.updateMemberInfo
        dispatch({
          type: 'UPDATE_USER_DETAILS',
          details: {
            ...data,
          },
        })
        dispatch({
          type: 'TOGGLE_BACKORDER_SMS_LOADING',
          value: false,
        })
      })
  }
}

export const updateQldPopupStatus = (val) => {
  return (dispatch) => {
    let { url, query } = config.members.update
    const postData = val
    const [mutationParams, inputParams, finalData] = convertPostDataIntoMutationParams(
      convertUpdateMemberPostData(postData)
    )

    query = query.replace('{mutationParams}', mutationParams).replace('{inputParams}', inputParams)

    return axios
      .post(
        url,
        {
          query,
          variables: finalData,
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        const data = response.data.data.updateMemberInfo
        dispatch({
          type: 'UPDATE_USER_DETAILS',
          details: {
            ...data,
          },
        })
      })
  }
}
